"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.doRequest = exports.fixSpm = exports.sendEzspmByLink = exports.sendEzspm = exports.genSpmLink = exports.getKeyword = exports.genTSpmStr = exports.genSpmString = exports.getPageId = exports.getWebCategoryId = exports.initEzspm = void 0;
var constant_1 = require("./constant");
var url_1 = require("./url");
var fingerprint_1 = require("./utils/fingerprint");
var utils_1 = require("./utils");
var domain_1 = require("./domain");
var runtime_1 = require("./runtime");
var requestSource = "/c.gif";
var runInBrowser = !runtime_1.isBrowser();
var env = {
    isUAT: false,
    isInEzbuyApp: false,
    countrycode: "SG",
    isSinglePage: false,
    isNewTights: false,
};
var getPlatformFromHostname = (function getPlatformFromHostname() {
    var platform = null;
    return function () {
        if (platform === null && runInBrowser) {
            platform = window.location.host.startsWith("m.")
                ? constant_1.Platform.MOBILE
                : constant_1.Platform.WEB;
        }
        return platform;
    };
})();
function initEzspm(isUAT, countrycode, platform, isInEzbuyApp, isSinglePage, isNewTights) {
    if (isUAT === void 0) { isUAT = false; }
    if (countrycode === void 0) { countrycode = "SG"; }
    env.isUAT = isUAT;
    env.countrycode = countrycode;
    if (platform !== undefined) {
        env.platform = platform;
    }
    else {
        env.platform = getPlatformFromHostname();
    }
    if (isInEzbuyApp !== undefined) {
        env.isInEzbuyApp = isInEzbuyApp;
    }
    if (isSinglePage !== undefined) {
        env.isSinglePage = isSinglePage;
    }
    if (isNewTights) {
        env.isNewTights = isNewTights;
    }
    if (runInBrowser && !document.cookie.includes("ez_cookie_id")) {
        var domain = domain_1.getRequestHost(env.platform === constant_1.Platform.WEB, env.isUAT, "");
        var host = domain.split(".").slice(-2).join(".");
        document.cookie = "ez_cookie_id=" + fingerprint_1.fingerprint() + ";domain=." + host + ";path=/;";
    }
    if (runInBrowser) {
        window.__EZSPM__ = env;
    }
}
exports.initEzspm = initEzspm;
function getWebCategoryId(link) {
    if (!runInBrowser) {
        return 0;
    }
    var _a = url_1.parseUrl(link).segments, segments = _a === void 0 ? [] : _a;
    if ((segments[0] === "newcategory" || segments[0] === "category") &&
        segments[1] !== undefined) {
        return segments[1];
    }
    return 0;
}
exports.getWebCategoryId = getWebCategoryId;
function getRequestUri() {
    if (!runInBrowser) {
        return;
    }
    var isMobile = env.platform === constant_1.Platform.MOBILE;
    var prefix = domain_1.isEzbuyTrunk() || utils_1.isEzbuyTrunkLocalDev()
        ? !isMobile
            ? "collect."
            : "mcollect."
        : "";
    var country = env.countrycode.toLocaleLowerCase();
    var host = domain_1.getRequestHost(isMobile, env.isUAT, country);
    return "//" + prefix + host + requestSource;
}
function getPlatform() {
    if (!runInBrowser) {
        return env.platform || constant_1.PLATFORM.WEB;
    }
    if (env.isInEzbuyApp) {
        var ua = window.navigator.userAgent;
        if (/android/i.test(ua)) {
            return constant_1.Platform.ANDROID;
        }
        else if (/iPad|iPhone|iPod/.test(ua)) {
            return constant_1.Platform.IOS;
        }
    }
    return env.platform === undefined ? getPlatformFromHostname() : env.platform;
}
function getPageId() {
    if (!runInBrowser) {
        return null;
    }
    var _a = url_1.parseUrl(location.href), segments = _a.segments, params = _a.params;
    var pathName = segments[0].toLowerCase().replace(/\.html$/, "");
    if (params.id && env.isNewTights) {
        return params.id;
    }
    if (pathName === "") {
        return constant_1.PAGEIDS.index;
    }
    else if (pathName.includes("promotion1")) {
        return window.tightsPageId || constant_1.PAGEIDS.notfound;
    }
    else if (pathName.includes("promotion")) {
        return window.bulmaPageId || constant_1.PAGEIDS.notfound;
    }
    else if (pathName.includes("product")) {
        return constant_1.PAGEIDS.products;
    }
    else if (pathName.includes("shop")) {
        return constant_1.PAGEIDS.sellerStore;
    }
    else if (constant_1.PAGEIDS.hasOwnProperty(pathName)) {
        return constant_1.PAGEIDS[pathName];
    }
    var pageMap = env.platform === constant_1.PLATFORM.WEB ? constant_1.webPageIds : constant_1.mobilePageIds;
    if (pageMap.hasOwnProperty(pathName)) {
        var pageId = pageMap[pathName];
        if (pageId === constant_1.PAGEIDS.default_listing && getKeyword(params) !== "") {
            pageId = constant_1.PAGEIDS.search_listing;
        }
        return pageId;
    }
    return constant_1.PAGEIDS.notfound;
}
exports.getPageId = getPageId;
function genSpmString(params) {
    return !env.isNewTights
        ? genSpmStr(params)
        : genTSpmStr(params);
}
exports.genSpmString = genSpmString;
function genSpmStr(params) {
    var _a = params.platform, platform = _a === void 0 ? getPlatform() : _a, channel = params.channel, _b = params.activityId, activityId = _b === void 0 ? 0 : _b, _c = params.content, content = _c === void 0 ? 0 : _c, _d = params.pageId, pageId = _d === void 0 ? getPageId() : _d;
    return platform + "." + pageId + "." + channel + "." + activityId + "." + String(content).replace(/\./g, "||");
}
function genTSpmStr(params) {
    var site = params.site, _a = params.platform, platform = _a === void 0 ? getPlatform() : _a, _b = params.channel, channel = _b === void 0 ? 0 : _b, _c = params.activityId, activityId = _c === void 0 ? 0 : _c, channelContent = params.channelContent;
    var pageId = params.pageId || getPageId();
    if (!channelContent) {
        console.error("ezspm 频道内容不能为空");
        return "";
    }
    return [
        "t",
        site,
        platform,
        pageId,
        channel,
        activityId,
        utils_1.genChannelContent2Str(channelContent),
    ].join(".");
}
exports.genTSpmStr = genTSpmStr;
function getKeyword(params) {
    var keyword = params.keyword, keywords = params.keywords, keyWords = params.keyWords;
    return keyword || keywords || keyWords || "";
}
exports.getKeyword = getKeyword;
function getProductId(params) {
    var gpid = params.gpid, productid = params.productid, producturl = params.producturl;
    return gpid || productid || producturl || "";
}
function genSpmLink(params, encode) {
    if (encode === void 0) { encode = true; }
    var ezspm = genSpmString(params);
    return url_1.genUrlWithSearch(params.url, { ezspm: ezspm }, encode);
}
exports.genSpmLink = genSpmLink;
function sendEzspm(params, extralInfo, encode) {
    if (extralInfo === void 0) { extralInfo = {}; }
    if (encode === void 0) { encode = true; }
    var ezspm = genSpmString(params);
    return doRequest(genRequestLink(__assign({ ezspm: ezspm }, extralInfo), encode));
}
exports.sendEzspm = sendEzspm;
function sendEzspmByLink(url, encode) {
    if (encode === void 0) { encode = true; }
    if (!runInBrowser) {
        return;
    }
    var _a = url_1.parseUrl(url), params = _a.params, segments = _a.segments;
    var categoryId = params.categoryId, transactionId = params.transactionId, ezspm = params.ezspm, baseGpid = params.baseGpid, pl = params.pl;
    if (ezspm === undefined) {
        return false;
    }
    var productid = segments[0] === "product"
        ? segments[1].replace(/\.html$/, "")
        : getProductId(params);
    var categoryid = segments[0] === "category" ||
        segments[0] === "newcategory" ||
        segments[0] === "categories"
        ? segments[1]
        : categoryId;
    return doRequest(genRequestLink({
        ezspm: ezspm,
        categoryid: categoryid,
        keyword: getKeyword(params),
        transactionid: transactionId,
        productid: productid,
        baseGpid: baseGpid,
        pl: pl,
    }, encode));
}
exports.sendEzspmByLink = sendEzspmByLink;
function fixSpm(ezspm) {
    if (!ezspm) {
        return ezspm;
    }
    var spmArr = ezspm.split(".");
    if (ezspm.toLocaleLowerCase().includes("share")) {
        spmArr[0] = "1" + spmArr[0];
    }
    if (spmArr[1].startsWith(constant_1.PAGEIDS.notfound)) {
        spmArr[1] = constant_1.PAGEIDS.notfound;
    }
    return spmArr.join(".");
}
exports.fixSpm = fixSpm;
function genRequestLink(params, encode) {
    if (encode === void 0) { encode = true; }
    var ezspm = params.ezspm;
    var searchParams = __assign(__assign({}, params), { ezspm: fixSpm(ezspm), catalog: env.countrycode, referrer: getReferrer(), ver: new Date().getTime() });
    return url_1.genUrlWithSearch(getRequestUri(), searchParams, encode);
}
function getReferrer() {
    return env.isSinglePage
        ? runInBrowser
            ? window.previousRoutePath
            : document.referrer
        : "";
}
function doRequest(url) {
    if (!runInBrowser) {
        return;
    }
    return (document.createElement("img").src = url);
}
exports.doRequest = doRequest;
